module.exports = require('react-router-dom');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_dva@2.1.0@dva/router.js
// module id = 592
// module chunks = 0